import { AlertDialog, Dialog } from "@kensho/neo";

import { SignInPrompt } from "./sign-in-prompt";

interface SignInDialogProps {
  isOpen: boolean;
  onClose?: () => void;
}

export function SignInDialog({ isOpen, onClose }: SignInDialogProps) {
  return onClose ? (
    <Dialog backdrop="light" isOpen={isOpen} title="Sign in" onClose={onClose}>
      <SignInPrompt />
    </Dialog>
  ) : (
    <AlertDialog backdrop="light" isOpen={isOpen} title="Sign in">
      <SignInPrompt />
    </AlertDialog>
  );
}
